import React, { createContext, useContext, useState } from 'react';

interface PolicyDetailContextValue {
  selectedPolicyId: string | null;
  setSelectedPolicyId: (id: string | null) => void;
}

const PolicyDetailContext = createContext<PolicyDetailContextValue>({
  selectedPolicyId: null,
  setSelectedPolicyId: () => {},
});

export const PolicyDetailProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedPolicyId, setSelectedPolicyId] = useState<string | null>(null);
  return (
    <PolicyDetailContext.Provider value={{ selectedPolicyId, setSelectedPolicyId }}>
      {children}
    </PolicyDetailContext.Provider>
  );
};

export const usePolicyDetail = () => useContext(PolicyDetailContext);
